module.exports = __webpack_public_path__ + "img/ic_sea.f7b0d3a3.svg";